import { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { api } from '@core/api.js';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/v1/auth/forgot-password', { email });
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <Alert severity="success">
        Si un compte existe pour cette adresse, un email de réinitialisation a été envoyé.
      </Alert>
    );
  }

  return (
    <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h5" fontWeight={700}>Mot de passe oublié</Typography>
      <Typography variant="body2" color="text.secondary">
        Entrez votre adresse email pour recevoir un lien de réinitialisation.
      </Typography>
      <TextField label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      <Button type="submit" variant="contained" disabled={loading}>Envoyer</Button>
      <Link component={RouterLink} to="/login" variant="body2">Retour à la connexion</Link>
    </Box>
  );
}
